(function (factory) {
    if (typeof define === 'function' && define.amd) {
        define(['jquery'], factory);
    } else if (typeof module === 'object' && module.exports) {
        module.exports = factory(require('jquery'));
    } else {
        factory(window.jQuery);
    }
}(function ($) {
    tinymce.PluginManager.add('previewPDF', function (editor, url) {
        editor.ui.registry.addButton('previewPDF', {
            text: 'Aperçu',
            onAction: function () {
                $.ajax({
                    type: 'post',
                    url: '/communication/preview-pdf',
                    data: { 'contenu': editor.getContent() },
                    dataType: 'json',
                    cache: false,
                    success: function (response) {
                        editor.windowManager.openUrl({
                            title: 'Aperçu PDF',
                            url: '/perso-pdf-generate?url='+response.path+'&lie_proposition='+$('#lie_proposition').is(':checked')+'&lie_apporteur='+$('#lie_apporteur').is(':checked')+'&lie_facture='+$('#lie_facture').is(':checked'),
                            width: 992,
                            height: 800,
                            buttons: [
                                {
                                    type: 'cancel',
                                    text: 'Fermer'
                                },
                                {
                                    type: 'custom',
                                    primary: true,
                                    text: 'Prévisualiser',
                                    classes: 'test'
                                }
                            ],
                            onAction: function(){
                                loadDossier(editor);
                            }
                        });
                    }
                });
            }
        });

        return {
            getMetadata: function () {
                return {
                    name: 'Aperçu PDF',
                };
            }
        };
    });
}));

/**
 * charge un dossier à partir de la référence donnée
 */
const loadDossier = function(editor){
    let dossier = $('iframe').contents().find('.dossier-reference');
    let propositionString = '';
    let apporteurString = '';
    let factureString = '';
    let proposition = $('iframe').contents().find('.propo-montage');
    let apporteur = $('iframe').contents().find('.apporteurs-preview');
    let facture = $('iframe').contents().find('.factures-preview');

    if(proposition.val() !== undefined && proposition.val() !== null){
        propositionString = '&proposition='+proposition.val();
    }

    if(apporteur.val() !== undefined && apporteur.val() !== null){
        apporteurString = '&apporteur='+apporteur.val()+'&apporteur_entite=apporteur';
    }

    if(facture.val() !== undefined && facture.val() !== null){
        factureString = '&facture='+facture.val();
    }

    $.ajax({
        type: 'post',
        url: '/communication/preview-pdf?dossier-reference='+dossier.val()+propositionString+apporteurString+factureString,
        data: { 'contenu': editor.getContent() },
        dataType: 'json',
        cache: false,
        success: function (response) {
            getProposFromDossier(response.id_dossier, response.id_proposition);
            getApporteursFromDossier(response.id_dossier, response.num_apporteur);
            getFacturesFromDossier(response.id_dossier, response.id_facture);

            $('iframe').contents().find('.libelle-dossier').text(response.libelle_dossier);
            $('iframe').contents().find('iframe').attr('src', response.path);
        }
    });
}
